var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionRedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42735",
    "data-name": "Group 42735",
    transform: "translate(6981 -7245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15992",
    "data-name": "Rectangle 15992",
    width: 16,
    height: 16,
    transform: "translate(-6981 7245)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-6980 7246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3050",
    "data-name": "Ellipse 3050",
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#d1131d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42734",
    "data-name": "Group 42734",
    transform: "translate(6.114 3.172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15991",
    "data-name": "Rectangle 15991",
    width: 1.773,
    height: 5.319,
    rx: 0.886,
    transform: "translate(0 2.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3051",
    "data-name": "Ellipse 3051",
    cx: 0.886,
    cy: 0.886,
    r: 0.886,
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionRedCircle);
export default __webpack_public_path__ + "static/media/attention-red-circle.040110324c84258f1d6c618082cac1d9.svg";
export { ForwardRef as ReactComponent };